import { render, staticRenderFns } from "./bandAandB.vue?vue&type=template&id=02472c7f&scoped=true"
import script from "./bandAandB.vue?vue&type=script&lang=js"
export * from "./bandAandB.vue?vue&type=script&lang=js"
import style0 from "./bandAandB.vue?vue&type=style&index=0&id=02472c7f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02472c7f",
  null
  
)

export default component.exports